import { Paper, Grid, Modal, Typography, Box, Tabs, Tab, IconButton } from '@mui/material';
import React, { useState, useEffect, useContext } from 'react';
import SearchBar from '../components/SearchBar';
import { AppFilterFields, SelectOptions } from '../../../interfaces/Common';
import JobCard from '../../../Components/JobCards';
import Filters from '../Filters';
import { getJobs, getJobsApply } from '../../../Utils/apiService';
import { AuthUser } from '../../../interfaces/Contexts';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import jobImgNoFilter from '../../../Assets/jobnofilter.png';
import JobCards from '../../../Components/JobCards';
import { useStyles } from '../styles';
import AppliedJobCards from '../components/JobCards';
import routes from '../../../Utils/routes';
import KenColors from '../../Events/utils/kenColors';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import CurrencyRupeeOutlinedIcon from '@mui/icons-material/CurrencyRupeeOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import { useNavigate } from 'react-router-dom';
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const MyJobs = () => {
  const classes = useStyles();
  const [filterData, setFilterData] = useState<AppFilterFields>({});
  const [appliedData, setAppliedData] = useState([]);
  const {
    state: { user },
  } = useContext(AuthContext);
  const userData = user as AuthUser;
  const [allAppliedData, setAllAppliedData] = useState([]);
  const [selectedValues, setSelectedValues] = useState<{ [key: number]: string }>({});
  const [jobFilterData, setJobFilterData] = useState([]);
  const [locations, setLocations] = useState<Array<SelectOptions>>([]);
  const [filter, setFilter] = useState<boolean>(false);
  const [value, setValue] = React.useState(0);
  const [jobsData, setJobsData] = useState([]);
  console.log(jobsData, "2345432");
  const navigate = useNavigate();

  const handleFilterCells = (data: string, key: string) => {
    const filterJobsApply = allAppliedData.filter((job: any) => {
      return job[key]?.toLowerCase().includes(data.toLowerCase());
    });
    setAppliedData(filterJobsApply);
    setFilterData({ ...filterData, [key]: data });
  };
  const filterJobs = (jobs: any[], criteria: Record<string, any[]>, name: string) => {
    console.log('Filtering jobs with criteria:', criteria, 'for section:', name);

    const filteredJobs: any = jobs.filter((job: any) =>
      Object.keys(criteria).every((key) => {
        if (key.includes('.')) {
          const [parentKey, childKey] = key.split('.');
          return job[parentKey] && criteria[key].some((value: any) => job[parentKey][childKey] === value);
        }
        return criteria[key].some((value: any) => job[key] === value);
      })
    );

    console.log('Filtered jobs:', filteredJobs);

    setAppliedData(filteredJobs);
    setSelectedValues([]);
  };

  const handleFilterOpen = () => {
    setFilter(!filter);
  };

  const handleFilterCancellation = () => {
    setFilterData({});
    handleFilterOpen();
  };

  useEffect(() => {
    getJobs(userData.applicantId)
      .then((res) => {
        setJobsData(res.data.myJobs);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);
  console.log('jobsDatajobsDatajobsData', jobsData);

  return (
    <div>
      {' '}
      <Paper
        sx={{
          marginTop: '-20px',
          height: '86vh',
          boxShadow: 'none',
          borderRadius: 2,
          '@media (min-width: 1280px) and (max-width: 1300px)': {
            height: '82vh !important',
          },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SearchBar
              handleDropDownChange={(e) => {
                console.log('7657656', e);
                handleFilterCells(e, 'Location__c');
              }}
              handleSearchChange={(e) => {
                console.log('7657656345', e);
                handleFilterCells(e, 'Job_Title__c');
              }}
              searchBarData={{ dropDown: filterData['Location__c'], input: filterData['Job_Title__c'] }}
              dropDownData={locations}
              handleFilter={handleFilterOpen}
            />
            <Modal open={filter} onClose={handleFilterCancellation} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
              <Filters
                handleClose={handleFilterCancellation}
                jobFilterData={jobFilterData}
                selectedValues={selectedValues}
                setSelectedValues={setSelectedValues}
                handleDropDownChange={(e: any) => {
                  delete e?.Salary;
                  filterJobs(allAppliedData, e, 'Applied');
                }}
              />
            </Modal>
          </Grid>
        </Grid>
        <Typography style={{fontSize:14,fontWeight:500,textAlign:"left"}} marginLeft={3}>Posted by me</Typography>
        <Box>
          <Grid container spacing={2} sx={{ margin: 1 }}>
            {jobsData?.slice(0, 3)?.map((props: any) => {
              return (
                <Grid item xs={12} sm={12} md={12} xl={4} lg={4}>
                  <div
                    style={{ cursor: 'pointer' }}
                    className={classes.jobsCard}
                    onClick={() => {
                      navigate(`${routes.jobDetails}/${props?.Id}`, { state: { breadCrumbs: props?.Job_Title__c } });
                    }}
                  >
                    <div className={classes.jobsCardHeader}>
                      <Box display={'flex'} gap={'14px'} alignItems={'start'}>
                        <Box bgcolor={"white"} height={'48px'} width={'48px'} className={classes.companyLogo} component={'img'} src={props?.Organization__r?.Logo_File_URL__c} alt="logo" />
                        <Box textAlign={'start'}>
                          <Typography fontWeight={'500'} fontSize={'15px'}>
                            {props?.Job_Title__c || '-'}
                          </Typography>
                          <Typography fontWeight={'400'} fontSize={'10.5px'}>
                            {props?.Organization__r?.Name} | {props?.Location__c}
                          </Typography>
                        </Box>
                      </Box>
                    </div>
                    <div className={classes.jobsContentContainer}>
                      <div>
                        <div className={classes.jobsContent}>
                          <WorkOutlineOutlinedIcon className={classes.jobsContentIcon} />
                          <Typography fontSize={'9px'} fontWeight={'400'} color={KenColors.ClientBlack2}>
                            Experience:&nbsp; {props?.Experience_Start_Level__c}-{props?.Experience_End_Level__c} Years
                          </Typography>
                        </div>
                        <div className={classes.jobsContent}>
                          <CurrencyRupeeOutlinedIcon className={classes.jobsContentIcon} />
                          <Typography fontSize={'10.5px'} fontWeight={'600'} color={KenColors.ClientBlack2}>
                            {props?.customSalary}
                          </Typography>
                        </div>
                        <div className={classes.jobsContent}>
                          <Typography fontSize={'9px'} fontWeight={'400'} color={KenColors.ClientBlack2}>
                            Posted By:
                          </Typography>
                          <Typography fontSize={'9px'} fontWeight={'400'} bgcolor={KenColors.kenWhite} padding={'4px 8px'} borderRadius={'20px'} color={KenColors.ClientBlue5}>
                            {props?.Posted_By__r?.Name}
                          </Typography>
                        </div>
                      </div>
                      <IconButton
                        onClick={() => {
                          navigate(`${routes.jobDetails}/${props?.Id}`, { state: { breadCrumbs: props?.Job_Title__c } });
                        }}
                      >
                        <ArrowForwardIcon className={classes.jobsActionIcon} />
                      </IconButton>
                    </div>
                  </div>
                </Grid>
              );
            })}

          </Grid>
        </Box>
      </Paper>
    </div>
  );
};

export default MyJobs;
